/** @format */

export const getGTMLabel = (str: string) =>
  str
    .toLowerCase()
    .replace(/[^a-zA-Z0-9 ]/g, '')
    .replaceAll(' ', '_');
